import React, { useEffect, useState } from 'react';
import Input from './Input';
import {
  getCurrencySymbol,
  getCurrencyDecimals,
  formatAmountForInput,
} from '../../utils/currency';

// Casas e separador vem da MOEDA, nao mais cravados no formato brasileiro:
// numa loja USD o campo de preco mostrava "10,00" em vez de "10.00".
const DECIMAL_SIZE = getCurrencyDecimals();

const InputMoney = ({ value, onChange, addonBefore = getCurrencySymbol(), ...props }) => {
  // Fallback para 0 caso o value seja undefined ou null
  const [currentValue, setCurrentValue] = useState(() => {
    const initialValue = value ?? 0;  // Se value for undefined ou null, usa 0
    return formatAmountForInput(initialValue);
  });

  useEffect(() => {
    if (value !== undefined && value !== null) {
      const valueString = value.toString();

      // Verifica se o valor não contém caracteres não numéricos
      if (!/\D/.test(valueString.replace('.', ''))) {
        setCurrentValue(formatAmountForInput(value));
      }
    }
  }, [value]);

  const handleOnChange = (event) => {
    // Aceita os dois separadores: aguenta valor que sobrou de outra moeda.
    const valueRemoved = String(event.target.value).replace(/[.,]/g, '');
    const sizeSlice = valueRemoved.length - DECIMAL_SIZE;

    // Garante que a formatação correta seja aplicada, separando os decimais
    const newValue = [valueRemoved.slice(0, sizeSlice), '.', valueRemoved.slice(sizeSlice)].join('');

    onChange({
      ...event,
      target: {
        ...event.target,
        value: newValue,
      },
    });
  };

  return (
    <Input addonBefore={addonBefore} value={currentValue} onChange={handleOnChange} {...props} />
  );
};

export default InputMoney;
